import http from './httpService';
import moment from 'moment/min/moment-with-locales';
/*global API */

const calendarEndpoint = `${API}/api/Calendar`;

export function createCalendarEvent(calendarEventForCreation) {
  const startUTC_Local_LLLL = moment.utc(calendarEventForCreation.start).local();
  const endUTC_Local_LLLL = moment.utc(calendarEventForCreation.end).local();

  return http.post(calendarEndpoint, {
    start: startUTC_Local_LLLL,
    end: endUTC_Local_LLLL,
    title: calendarEventForCreation.title,
    description: calendarEventForCreation.description,
    attendees: JSON.stringify(calendarEventForCreation.attendees),
  });
}

export function updateCalendarEvent(calendarEventForUpdate) {
  const startUTC_Local_LLLL = moment.utc(calendarEventForUpdate.start).local();
  const endUTC_Local_LLLL = moment.utc(calendarEventForUpdate.end).local();

  return http.put(calendarEndpoint, {
    id: calendarEventForUpdate.id,
    start: startUTC_Local_LLLL,
    end: endUTC_Local_LLLL,
    title: calendarEventForUpdate.title,
    description: calendarEventForUpdate.description,
    attendees: JSON.stringify(calendarEventForUpdate.attendees),
  });
}

export function getEventsForTheMonth() {
  return http.get(calendarEndpoint);
}

export function deleteCalendarEvent(id) {
  return http.delete(calendarEndpoint, { params: { calendarEventId: id } });
}
